const MuiLinearProgress = {
  styleOverrides: {
    root: () => {
      return {
        borderRadius: "100px"
      };
    }
  }
};
export {
  MuiLinearProgress
};
//# sourceMappingURL=MuiLinearProgress.js.map
